export default "__VITE_ASSET__hLDD6IiW__"